<template>
  <div :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" @mouseenter.stop="controlMouseOver(component, index)"
       @click="controlClick(component, index)" class="rc-combobox" ref="rcComboboxDesign">
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name"
                  ref='elFormItem' :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain"
                  :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-tooltip popper-class="file-tooltip-combobox" transition="''" :visible-arrow="false" effect="light"
                  placement="bottom-start" :disabled="fileToolTipDisabled">
        <div slot="content">
          <div v-for="(pic,index) in currentSelectFile"
               class="file-cotent"
               :key="index">
            <span class="item" :title="pic.name">{{pic.name}}</span>
            <span class="download" @click.stop="downFile(pic)"><i class="el-icon-download"></i>下载</span>
            <span class="preivew" @click.stop="preivewFile(pic)"><i class="el-icon-view"></i>预览</span>
          </div>
        </div>
        <el-select :value="textValue | format"
                   ref="rcCombobox"
                   :disabled="disabled || component.properties.readonly"
                   :placeholder="component.properties.placeholder||'请选择'"
                   :multiple="component.properties.multiple"
                   :filterable="component.properties.search"
                   :title="getShowCurrentValue | format"
                   :class="[{'multiple-combobox': component.properties.multiple}, inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                   :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                   no-data-text="无匹配数据"
                   @change="changValue"
                   clearable
                   @focus="setOptionsWidth"
                   @visible-change="visableChange"
                   @mouseleave.native.stop="visableHidden"
                   @mouseenter.native.stop="hoverToVisible">
        <span v-if="component.properties.multiple" slot="prefix">
          <template v-if="component.properties.search">
            <span :style="{width: getSpanWidth}" v-show="getShowCurrentValue !== ''" class="show-name">{{ getShowCurrentValue }}</span>
            <el-input ref="rcComboboxMultipeInput" :disabled="this.inputDisabled" :class="[getShowCurrentValue !== '' && 'clearPadding']"
                      :style="{width: `${parentWidth - parseFloat(getSpanWidth)}px`}" v-model="keywords"
                      :placeholder="getShowCurrentValue !== '' ? '' : '请选择'" @focus.stop="openOptions"
                      @blur="clearKeywords" :clearable="getShowCurrentValue === ''"></el-input>
          </template>
          <template v-else>
            <span class="no-search">{{getShowCurrentValue}}</span>
          </template>
        </span>
          <el-option
            @mouseenter.native.stop="clearHoverTimeout"
            @mouseleave.native.stop="visableHidden"
            v-for="(item, index) in showOptions"
            :title="item.value"
            :key="index"
            :label="item.value | format"
            :value="item.id"
            :class="getClassByCopy">
          </el-option>
          <!-- 如果是静态单选模板，并且开启了新增属性功能，则新增一个 其他请填写 -->
          <template v-if="getShowOther">
            <el-option :value="otherId" class="other-option" disabled ref="ohterOptions"
                       @mouseenter.native.stop="clearHoverTimeout" @mouseleave.native.stop="visableHidden">
              <template>
                <span class="span-edit" v-if="!edit" :style="{width: otherOptionsWidth + 'px'}" @click.stop="addOption">自定义填写</span>
                <div v-else class="input-content" :style="{width: otherOptionsWidth + 'px'}">
                  <el-input v-model="otherContent" placeholder="其他请填写" ref="otherInput"
                            @keyup.enter.native="saveOption"></el-input>
                </div>
              </template>
              <i class="el-icon-check" @click.stop="saveOption"></i>
            </el-option>
          </template>
        </el-select>
      </el-tooltip>
    </el-form-item>
  </div>
</template>

<script>
import { componentMixin, inputMixin, relFunMixin, defaultValueMixin, dataSource, calculationMixin } from './mixins'
import { UUID } from '@/plugins/common'
import { textWidth } from '@utils'

export default {
  name: 'rc-combobox',
  mixins: [componentMixin, inputMixin, relFunMixin, dataSource, defaultValueMixin, calculationMixin],
  props: ['component', 'value', 'index', 'disabled', 'labelParameter', 'tableRelationId', 'tableCtrlKey'],
  inject: ['initState', 'dataService'],
  data () {
    return {
      loading: false,
      options: [],
      currentValue: '',
      needRequest: false,
      isRequest: false,
      keywords: '',
      parentWidth: '',
      showOptions: [],
      canOpen: true,
      otherId: '',
      // 是否开启编辑
      edit: false,
      // 设置宽度，要不然宽度自适应会导致切换的时候选项宽度变化
      otherOptionsWidth: '',
      // 新增的选项内容
      otherContent: '',
      hoverTimeout: null,
      screenWidth: document.body.clientWidth,
      inputDisabled: false
    }
  },
  created () {
    this.otherId = UUID.create()
    this.isRequest = true
    // 表格控件交互导致控件重新实例化会清空当前选值, 这里需要重新赋值
    if (this.index !== undefined && this.initState.state) {
      this.initOptions()
      this.getValue()
    }
  },
  filters: {
    format: function (value) {
      if (!value) return ''
      if (typeof value === 'number') {
        value = value + ''
      }
      // 数字转字符串, 数字没有 includes 方法
      if (value.includes('$.$')) {
        let array = []
        value.split('$.$').forEach(m => {
          if (m) {
            array.push({'name': m.split(',/')[0], 'link': '/' + m.split(',/')[1]})
          }
        })
        return array.map(e => e.name).join()
      } else {
        return value
      }
    }
  },
  watch: {
    'value' (val) {
      if (this.initState.state) {
        this.getValue()
      }
    },
    'initState.state' (val) {
      if (val) {
        this.initOptions()
        this.initValue()
      }
    },
    'isRequest' (val) {
      if (val === false && this.options.length === 0) {
        this.initOptions()
      }
    },
    'getShowValue' (val) {
      if (this.component.properties.multiple && this.component.properties.search) {
        this.keywords = ''
      }
      if (this.component.properties.archived.showColumnId) {
        // 数字没有 includes方法。。
        if (this.options && this.options.find(m => String(this.value) && String(this.value).includes(m.id))) {
          this.update({value: val, archiveColumnId: this.component.properties.archived.showColumnId})
        } else {
          this.update('')
          this.update({value: val, archiveColumnId: this.component.properties.archived.showColumnId})
        }
      }
    },
    keywords (val) {
      if (this.canOpen) {
        this.openOptions()
      } else {
        this.canOpen = true
      }
      this.showOptions = []
      this.$nextTick(() => {
        this.showOptions = this.options.filter(item => {
          item.value += ''
          return item.value.includes(val)
        })
      })
    },
    options (val) {
      this.showOptions = [...val]
    },
    tempValue (val) {
      // 未归档的默认值赋值
      if (!this.component.archive.enable && !this.value && this.value !== 0) {
        this.currentValue = val
      }
    },
    screenWidth: {
      handler (newVal, oldVal) {
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
          this.screenWidth = newVal
          this.timer = true
          let that = this
          setTimeout(function () {
            that.timer = false
            if (!that.disabled) {
              let rcCombobox = that.$refs.rcComboboxDesign
              if (rcCombobox) {
                let dom = rcCombobox.querySelector('.el-form-item .el-form-item__content .multiple-combobox .el-input--prefix .el-input__prefix span')
                that.parentWidth = dom ? dom.offsetWidth : ''
              }
            }
          }, 400)
        }
      },
      immediate: true
    },
    getShowCurrentValue () {
      if (!this.disabled) {
        let rcCombobox = this.$refs.rcComboboxDesign
        if (rcCombobox) {
          let dom = rcCombobox.querySelector('.el-form-item .el-form-item__content .multiple-combobox .el-input--prefix .el-input__prefix span')
          this.parentWidth = dom ? dom.offsetWidth : ''
        }
      }
    }
  },
  methods: {
    initComponent () {
      if (!this.initState.state) return false
      this.initValue()
      // 非表格内的下拉框初使化时要重新初始化选项
      if (this.index === undefined) {
        this.initOptions()
      }
    },
    async initOptions () {
      let isDispose = false
      const changerrr = () => {
        isDispose = true
      }
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
        await this.loadDataSourceOptions(changerrr)
        await this.eventBus.$emit('form.afterSourceOptions', {id: this.component.id, el: this})
      } else {
        changerrr()
        await this.loadTemplateOptions()
      }
      // let isDispose = false
      if (isDispose) {
        let unWatch = this.$watch(() => this.value, val => {
          if (val) {
            this.updateCurrentValue()
            unWatch()
          }
          // 2秒后没有监听到值改变 销毁监听
          setTimeout(() => !isDispose && unWatch(), 2000)
        }, {deep: true})
      }
    },
    async initValue () {
      await this.getValue()
      await this.eventBus.$emit('form.afterSourceOptions', {id: this.component.id, el: this})
    },
    changValue (value) {
      if (value === this.otherId) {
        return false
      }
      this.currentValue = value
      if (this.component.properties.multiple && this.component.properties.search) {
        this.$refs.rcComboboxMultipeInput.focus()
      }
      this.eventBus.$emit('form.comboboxChange', {id: this.component.id, value: value, el: this})
      this.eventBus.$emit('form.select-master-agreement', {component: this.component, value: value})
      if (this.component.archive.enable) {
        // 开启了归档才更新值
        if (value === null || value === undefined) {
          this.update('')
        } else {
          this.update(this.component.properties.multiple ? value.join(', ') : value)
        }
        // 开启了绑定数据源
        if (this.component.properties.dataSource.bindData.enable && this.component.properties.dataSource.bindData.dataBinding.length > 0) {
          this.component.properties.dataSource.bindData.dataBinding.forEach(d => {
            if (this.component.properties.multiple) {
              let os = value.map((el) => {
                let o = this.options.find(e => e.id === el)
                if (o) {
                  return o[d.showColumnId]
                }
              })
              this.update({
                'value': value === null || value === undefined || value === '' ? '' : os.join(','),
                'archiveColumnId': d.componentId
              })
            } else {
              let o = this.options.find(e => e.id === value)
              this.update({
                'value': value === null || value === undefined || value === '' ? '' : o[d.showColumnId],
                'archiveColumnId': d.componentId
              })
            }
          })
        }
      }
      this.$refs.elFormItem.validate('blur')
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    },
    getValue () {
      if (this.component.properties.multiple) {
        if (this.value) {
          this.currentValue = this.value.split(', ')
        } else if (typeof this.value === 'string') {
          this.currentValue = []
        }
      } else {
        if (this.value !== undefined) {
          this.currentValue = this.value
        }
      }
    },
    setOptionsWidth () {
      let doc = document.querySelectorAll('.el-select-dropdown')
      doc.length && doc.forEach(e => {
        e.style.width = this.$refs.elFormItem.$el.childNodes[1].childNodes[0].clientWidth + 'px'
      })
      this.controlClick(this.component, this.index)
    },
    getStrLength (str) {
      let width = 0
      if (str) {
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            width += 12
          } else {
            width += str.charCodeAt(i) === 32 ? 3 : 6
          }
        }
      }
      return width
    },
    openOptions () {
      setTimeout(() => {
        if (!this.$refs.rcCombobox.$data.visible) {
          this.$refs.rcCombobox.$data.visible = true
        }
      }, 300)
    },
    clearKeywords () {
      setTimeout(() => {
        if (this.keywords && this.keywords.trim() !== '') {
          if (!this.$refs.rcCombobox.$data.visible) {
            this.canOpen = false
            this.keywords = ''
          }
        }
      }, 200)
    },
    updateCurrentValue () {
      if (this.value && this.component.properties.dataSource && this.component.properties.dataSource.enable && !this.component.properties.multiple) {
        let item = this.options.find(c => c.id === this.value)
        if (!item) {
          if (this.tableRelationId) {
            this.currentValue = this.dataService.data[this.tableRelationId][this.component.properties.archived.showColumnId]
          } else {
            this.currentValue = this.dataService.data[this.component.properties.archived.showColumnId]
          }
        }
      }
    },
    formatPicData (data) {
      let array = []
      if (data) {
        data.split('$.$').forEach(m => {
          if (m) {
            array.push({'name': m.split(',/')[0], 'link': '/' + m.split(',/')[1]})
          }
        })
      }
      return array
    },
    downFile (item) {
      if (item.link.includes('http')) {
        const x = new XMLHttpRequest()
        x.open('GET', item.link, true)
        x.responseType = 'blob'
        x.onload = function (e) {
          const url = window.URL.createObjectURL(x.response)
          const a = document.createElement('a')
          a.href = url
          a.download = item.name
          a.click()
        }
        x.onerror = function () {
          window.open(item.link)
        }
        x.send()
      } else {
        window.open(`${location.origin}/shared-api/files/download?data=${encodeURIComponent('$.$')}${encodeURIComponent(item.name)},${item.link}`)
      }
    },
    preivewFile (item) {
      // 非 doc、docx、xls、xlsx 走 view 接口
      if (item.link) {
        let src = item.link
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: item.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif'].includes(type)) {
          let href = this.$router.resolve({
            name: 'imagePreview',
            query: {src: src.includes('http') ? src : sessionStorage.getItem('ossDownloadUrl') + src, name: item.name}
          }).href
          window.open(href, '_blank')
        } else if (['pdf', 'txt'].includes(type)) {
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
        } else if (type === 'ofd') {
          const ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
          this.$axios.get(`/shared-api/files/ofdConvertPdf?url=${ossDownloadUrl}${src}`).then(res => {
            window.open(`${ossDownloadUrl}${res.data}`)
          })
        } else {
          this.$message.info('暂不支持该类型文件预览！')
        }
      }
    },
    addOption () {
      let width = this.$refs.ohterOptions.$el.offsetWidth
      this.otherOptionsWidth = width - 65
      this.edit = !this.edit
      this.$nextTick(() => {
        if (this.edit) {
          // 默认聚焦
          this.$refs.otherInput.focus()
        }
      })
    },
    // 选项关闭的时候清空内容并且修改状态
    visableChange (val) {
      this.edit = !val
      this.otherContent = ''
    },
    // 如果是划动到选项那里不隐藏
    clearHoverTimeout () {
      if (this.component.properties.hoverToVisible && this.hoverTimeout) {
        clearTimeout(this.hoverTimeout)
        this.hoverTimeout = null
      }
    },
    // 鼠标离开时隐藏
    visableHidden () {
      if (this.component.properties.hoverToVisible) {
        this.hoverTimeout = setTimeout(() => {
          this.$refs.rcCombobox.blur()
        }, 300)
      }
    },
    // 悬浮展示
    hoverToVisible () {
      if (this.component.properties.hoverToVisible) {
        this.$refs.rcCombobox.$el.querySelector('input').click()
      }
    },
    // 保存添加的选项
    saveOption () {
      if (!this.edit) return false
      if (!this.otherContent) return this.$message.error('请输入内容')
      // 添加的数据不能重复
      let findOptions = this.options.find(c => c.id === this.otherContent)
      let multiple = this.component.properties.multiple
      if (!findOptions) {
        this.options.push({id: this.otherContent, value: this.otherContent})
        // 默认选中当前添加的选项
        let value = multiple ? [...this.currentValue, this.otherContent] : this.otherContent
        this.changValue(value)
      } else {
        // 否则选中
        let value = findOptions.value
        if (multiple) {
          let index = this.currentValue.findIndex(c => c === this.otherContent)
          value = index > -1 ? this.currentValue : [...this.currentValue, findOptions.value]
        }
        this.changValue(value)
      }
      this.edit = false
      this.otherContent = ''
    },
    widthWatch () {
      return (() => {
        window.screenWidth = document.body.clientWidth
        this.screenWidth = window.screenWidth
      })()
    }
  },
  computed: {
    getShowValue () {
      // 筛选项计算请求没结束的时候不去渲染展示值
      if (this.needRequest && this.isRequest) {
        return ''
      }
      let value = []
      let currentValues = []
      if (!(this.currentValue instanceof Array)) {
        currentValues.push(this.currentValue)
      } else {
        currentValues = this.currentValue
      }
      currentValues.forEach(m => {
        let option = this.options.find(n => n.id === m)
        if (option) {
          value.push(option.value)
        }
      })
      return value.join(', ')
    },
    getShowCurrentValue () {
      let value = []
      if (this.currentValue) {
        if (!(this.currentValue instanceof Array)) {
          let item = this.options.find(n => n.id === this.currentValue)
          item && value.push(item.value)
        } else {
          this.currentValue.forEach(c => {
            let item = this.options.find(n => n.id === c)
            item && value.push(item.value)
          })
        }
      }
      return value.join(', ')
    },
    getSpanWidth () {
      let width = 0
      if (this.parentWidth) {
        // 最大宽度为90%
        let maxWidth = this.parentWidth * 0.9
        if (this.getShowCurrentValue && this.getShowCurrentValue.length) {
          let strWidth = textWidth(this.getShowCurrentValue, ' 12px')
          width = strWidth >= maxWidth ? maxWidth : strWidth
        }
        return `${width + 5}px`
      } else {
        this.$nextTick(() => {
          // 最大宽度为60%
          let maxWidth = this.parentWidth
          if (this.getShowCurrentValue && this.getShowCurrentValue.length) {
            let strWidth = this.getStrLength(this.getShowCurrentValue)
            width = strWidth >= maxWidth ? maxWidth : strWidth
          }
        })
      }
    },
    handling () {
      let text = ''
      // 开启了数据源但还没请求到辅助表数据的情况下先不展示
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable && this.options.length === 0) {
        return ''
      }
      if (this.component.properties.multiple && typeof (this.currentValue) !== 'string') {
        this.currentValue.forEach((el, index) => {
          let option = this.options.find(item => {
            return item.id === el
          })
          text += (index === 0 ? '' : ',') + (option ? option.value : el)
        })
      } else {
        let option = this.options.find(item => {
          return item.id === this.value
        })
        text = option ? option.value : this.value
      }
      return text
    },
    fileToolTipDisabled () {
      // todo: 使用值是否含$.$符号来判断是否文件, 不够准确
      return !String(this.getShowCurrentValue).includes('$.$')
    },
    currentSelectFile () {
      let currentSelectFile = []
      if (String(this.getShowCurrentValue).includes('$.$')) {
        currentSelectFile = this.formatPicData(this.getShowCurrentValue)
      }
      return currentSelectFile
    },
    // 是否显示其他选项
    // 只有静态单选模板需要展示
    getShowOther () {
      return this.component.properties.addOptions && !(this.component.properties.dataSource && this.component.properties.dataSource.enable)
    },
    // 开启了数据源但还没请求到辅助表数据的情况下先不展示，选项中没有当前项，展示另一个归档
    textValue () {
      let currentValue = this.currentValue
      // 非数据源下拉框没有双归档
      if (this.value && this.component.properties.dataSource && this.component.properties.dataSource.enable && !this.component.properties.multiple) {
        const showColumnId = this.component.properties.archived.showColumnId
        // 如果选项找不到用另一个归档
        if (!this.options.find(c => c.id === this.value)) {
          // 如果是表格，先找到表格的归档表再找另一个归档
          currentValue = this.tableRelationId ? this.dataService.data[this.tableRelationId][this.index][showColumnId] : this.dataService.data[showColumnId]
        }
      }
      return currentValue
    }
  },
  mounted () {
    if (this.component.properties.readonly === true && this.component.properties.multiple === true && this.component.properties.search === true) {
      this.inputDisabled = true
    }
    window.addEventListener('resize', this.widthWatch)
    // 表单中如果有多个多选可搜索下拉，但是布局不一样，会导致获取的宽度不一致
    if (!this.disabled) {
      let rcCombobox = this.$refs.rcComboboxDesign
      if (rcCombobox) {
        let dom = rcCombobox.querySelector('.el-form-item .el-form-item__content .multiple-combobox .el-input--prefix .el-input__prefix span')
        this.parentWidth = dom ? dom.offsetWidth : ''
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.widthWatch)
  }
}
</script>
<style lang="scss">
.rc-combobox {
  > div {
    width: 100%;
  }

  .el-form-item {
    .el-form-item__content {
      .multiple-combobox {
        .el-select__tags {
          display: none;
        }

        .el-input--prefix {
          .el-input__inner {
            padding-left: 15px;
          }

          .el-input__prefix {
            padding-left: 11px;
            color: #363636;
            width: calc(100% - 36px);

            span {
              width: 100%;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .show-name {
                font-size: 12px;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
              }

              .el-input {
                border: none;
                height: 26px;
                line-height: 26px;

                .el-input__inner {
                  border: none;
                  height: 26px;
                  line-height: 26px;
                  padding-left: 0;
                }

                .el-input__suffix {
                  width: 25px;
                }
              }

              .clearPadding {
                .el-input__inner {
                  padding-right: 0;
                }
              }

              .no-search {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
                font-size: 12px;
                display: inline-block;
              }
            }
          }
        }
      }

      .el-select.el-tooltip {
        margin-right: 0;
        width: 100%;
      }
    }
  }
}

.rc-combobox.hidden {
  >div {
    width: 100%;
  }
  .el-form-item {
    .el-form-item__content {
      margin-left: 0px !important;
      .multiple-combobox {
        .el-select__tags {
          display: none;
        }
        .el-input--prefix {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__prefix {
            padding-left: 11px;
            color: #363636;
            width: calc(100% - 36px);
            span {
              width: 100%;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .show-name {
                font-size: 12px;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
              }
              .el-input {
                border: none;
                height: 26px;
                line-height: 26px;
                .el-input__inner {
                  border: none;
                  height: 26px;
                  line-height: 26px;
                  padding-left: 0;
                }
                .el-input__suffix {
                  width: 25px;
                }
              }
              .clearPadding {
                .el-input__inner {
                  padding-right: 0;
                }
              }
              .no-search {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
                font-size: 12px;
                display: inline-block;
              }
            }
          }
        }
      }
      .el-select.el-tooltip{
        margin-right: 0;
        width:100%;
      }
    }
  }
}

.rc-combobox.to-top {
  >div {
    width: 100%;
  }
  .el-form-item {
    .el-form-item__label{
      float: none;
      padding-left: 12px !important;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      .component-explain-tooltip.el-tooltip{
        left: 97px;
        top:-21px
      }
      .multiple-combobox {
        .el-select__tags {
          display: none;
        }
        .el-input--prefix {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__prefix {
            padding-left: 11px;
            color: #363636;
            width: calc(100% - 36px);
            span {
              width: 100%;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .show-name {
                font-size: 12px;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
              }
              .el-input {
                border: none;
                height: 26px;
                line-height: 26px;
                .el-input__inner {
                  border: none;
                  height: 26px;
                  line-height: 26px;
                  padding-left: 0;
                }
                .el-input__suffix {
                  width: 25px;
                }
              }
              .clearPadding {
                .el-input__inner {
                  padding-right: 0;
                }
              }
              .no-search {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
                font-size: 12px;
                display: inline-block;
              }
            }
          }
        }
      }
      .el-select.el-tooltip{
        margin-right: 0;
        width:100%;
      }
    }
  }
}
.el-select-dropdown__list {

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: var(--light-9, #EBF6FF);
  }
}

.el-select-dropdown {
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .other-option {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span, i {
            color: #606266;
          }

          &:hover {
            background-color: #EBF6FF;

            span {
              color: #55ACF1;
            }

            i {
              color: #55ACF1;

              &:active {
                color: #388DD2;
              }
            }
          }

          .input-content {
            .el-input {
              width: 100%;

              .el-input__inner {
                width: 100%;
                padding: 0 5px;
              }
            }
          }

          .span-edit {
            display: inline-block;
            width: calc(100% - 20px);
          }
        }
      }
    }
  }
}

.file-tooltip-combobox.el-tooltip__popper.is-light {
  width: 260px;
  padding: 10px 0;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

  .file-cotent {
    height: 26px;
    width: 100%;
    line-height: 26px;
    padding: 0 10px;

    &:hover {
      background-color: #E2F1FE;
    }
  }

  .file-cotent + .file-cotent {
    margin-top: 10px;
  }

  span.item {
    display: inline-block;
    width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  span.download, span.preivew {
    display: inline-block;
    width: 60px;
    cursor: pointer;
    color: #55ACF1;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-combobox.vue